import React from 'react';
import { FaCheckCircle, FaClock, FaBoxOpen } from 'react-icons/fa';
import {
  getEstadoProductoMaster,
  getEstadoProductoMasterLabel,
  getEstadoProductoMasterTheme,
  isProductoMasterImportado
} from '../../../utils/masterCatalogProduct';

const ICONS = {
  check: FaCheckCircle,
  clock: FaClock,
  box: FaBoxOpen
};

export default function EstadoProductoMasterBadge({ producto, stockSucursal, showIcon = true, size = 'sm' }) {
  if (!isProductoMasterImportado(producto)) return null;

  const estado = getEstadoProductoMaster(producto, stockSucursal);
  const label = getEstadoProductoMasterLabel(estado);
  const theme = getEstadoProductoMasterTheme(estado);
  const Icon = ICONS[theme.icon] || FaClock;
  const sizeClass = size === 'xs' ? 'text-[10px] px-1.5 py-0' : 'text-xs px-2 py-0.5';

  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border font-semibold ${sizeClass} ${theme.badgeClass}`}
      title={theme.tooltip}
    >
      {showIcon && <Icon className="shrink-0 opacity-80" aria-hidden />}
      {label}
    </span>
  );
}
